export default function(value: number) {
  switch (value) {
    case 101: return '消费积分';
    case 102: return '活动积分';
    case 103: return '其他';
    case -101: return '积分兑换';
    case -102: return '其他';
    case 201: return '签到';
    case 202: return '线下签到';
    case 203: return '连续签到';
    case -301: return '大转盘抽奖';
    case -402: return '积分兑换礼品';
    case 501: return '扫码消费积分';
    case 502: return '扫码活动积分';
    case 503: return '扫码其他';
    case -501: return '扫码积分兑换';
    case -502: return '扫码其他';
    case 601: return '推荐关注';
    case 602: return '被推荐关注';
    case 701: return '扫码支付积分';
    case 801: return '商城支付积分';
    case 802: return '商城积分抵现';
    case 901: return '会员卡开卡礼';
    case 902: return '会员卡消费';
    case 904: return '储值卡商城消费';
    case 1001: return '刮刮卡活动积分';
    case 1002: return '大转盘活动积分';
    case 1003: return '微暗号活动积分';
    case 1004: return '编码兑奖活动积分';
    case 1100: return '积分折算';
    default: return '其他';
  }
}
